import {
	AlertCircle,
	CheckCircle,
	Clock,
	Hourglass01,
	InfoCircle,
	RefreshCcw01,
	XCircle,
} from "@untitledui/icons";
import type { ComponentType, SVGProps } from "react";
import { cx } from "@/utils/cx";
import type { InfractionStatusBannerIcon } from "../constants/infraction-status-banner.constant";
import { resolveInfractionStatusBanner } from "../constants/infraction-status-banner.constant";

const STATUS_BANNER_ICONS: Record<
	InfractionStatusBannerIcon,
	ComponentType<SVGProps<SVGSVGElement>>
> = {
	hourglass: Hourglass01,
	"check-circle": CheckCircle,
	"x-circle": XCircle,
	"alert-circle": AlertCircle,
	clock: Clock,
	refresh: RefreshCcw01,
	info: InfoCircle,
};

export type InfractionStatusBannerCardProps = {
	displayStatus: number;
	statusCode: number;
	statusLabel: string;
	className?: string;
};

export function InfractionStatusBannerCard({
	displayStatus,
	statusCode,
	statusLabel,
	className,
}: InfractionStatusBannerCardProps) {
	const banner = resolveInfractionStatusBanner(
		displayStatus,
		statusCode,
		statusLabel
	);
	const Icon = STATUS_BANNER_ICONS[banner.icon];
	const isCircularLayout = banner.layout === "circular";

	return (
		<div
			className={cx(
				"flex items-start rounded-lg border p-4",
				isCircularLayout ? "gap-3" : "gap-4",
				banner.palette.root,
				className
			)}
			data-slot="infraction-status-banner-card"
		>
			{isCircularLayout ? (
				<div
					className={cx(
						"flex size-9 shrink-0 items-center justify-center rounded-full",
						banner.palette.circularIconWrapper
					)}
				>
					<Icon
						aria-hidden
						className={cx("size-5", banner.palette.circularIcon)}
					/>
				</div>
			) : (
				<div
					className={cx(
						"flex size-9 shrink-0 items-center justify-center rounded",
						banner.palette.squareIconWrapper
					)}
				>
					<Icon
						aria-hidden
						className={cx("size-5", banner.palette.squareIcon)}
					/>
				</div>
			)}

			<div className="flex min-w-0 flex-1 flex-col gap-0.5">
				<p
					className={cx("font-bold text-sm", banner.palette.title)}
					data-slot="infraction-status-banner-title"
				>
					{banner.title}
				</p>
				<p
					className={cx(
						"opacity-90",
						banner.palette.description,
						banner.layout === "square" ? "text-xs" : "text-sm"
					)}
					data-slot="infraction-status-banner-description"
				>
					{banner.description}
				</p>
			</div>
		</div>
	);
}
